import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import dynamic from 'next/dynamic';
import { useSiteContext } from '../components/SiteContext';
import loading from './loading';
import InView from '../components/InView';

const hasAdunit = (
  newsboard: string | null | undefined,
): boolean => Boolean(
  newsboard && !['FASHIONUNITED_INFO'].includes(newsboard),
);

const DynamicAdUnit = dynamic(
  // @ts-expect-error sizes PropTypes nominal type mismatch
  () => import('@fuww/library/src/Advertisement'),
  {
    loading,
    ssr: false,
  },
) as React.ComponentType<Record<string, unknown>>;

const adUnitPropertyTypes = {
  adUnit: PropTypes.string.isRequired,
};

type AdUnitProperties = InferProps<typeof adUnitPropertyTypes>
  & Record<string, unknown>;

const AdUnit = ({
  adUnit,
  ...properties
}: AdUnitProperties) => {
  const { adUnitPrefix } = useSiteContext();

  return (
    <InView>
      <DynamicAdUnit
        {...properties}
        adUnit={`${adUnitPrefix}/${adUnit}`}
        dfpNetworkId="53457124"
      />
    </InView>
  );
};

AdUnit.propTypes = adUnitPropertyTypes;

export default AdUnit;
export { hasAdunit };
